'use client'

import { SubmitButton } from '@/components/forms/submit-button'
import { cn } from '@/lib/utils'

type AuthSubmitButtonProps = React.ComponentProps<typeof SubmitButton>

// INFO: the auth shell's full-width dark gradient submit control
export function AuthSubmitButton({ className, ...props }: AuthSubmitButtonProps) {
	return (
		<SubmitButton
			className={cn(
				'h-10 w-full bg-gradient-to-b from-[#262b36] to-[#090b10] text-[#edf1f9] shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] hover:from-[#343a47] hover:to-[#090b10]',
				className,
			)}
			{...props}
		/>
	)
}
